"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Takes an imported or required object and converts it to an array of its own properties.
 */
function importToArray(importObject) {
    const keys = Object.getOwnPropertyNames(importObject);
    // ES6 / TypeScript exports contain a __esModule property. Don't include that.
    return keys.filter(key => key.indexOf("__") !== 0).map(key => importObject[key]);
}
exports.importToArray = importToArray;
exports.default = importToArray;
